import { getClientSummary } from '@/api/client';
import { getUserSummary, login } from '@/api/user';
import { resolveTargetClientId } from './client-id';
import { ClientSummary } from '@/types/client';
import { UserLogin, UserSummary } from '@/types/user';

export interface AuthBootstrapResult {
  loginResponse: UserLogin;
  userSummary: UserSummary;
  clientSummary: ClientSummary | null;
  activeClientId: string | null;
}

export async function bootstrapAuthenticatedUser({
  idToken,
  preferredClientId,
  partner,
}: {
  idToken: string;
  preferredClientId?: string;
  partner?: string;
}): Promise<AuthBootstrapResult> {
  const loginResponse = await login(idToken, partner);

  if (loginResponse.type === 'internal') {
    const activeClientId = resolveTargetClientId(
      loginResponse.id,
      loginResponse.client_ids || [],
      preferredClientId
    );
    return {
      loginResponse,
      userSummary: loginResponse,
      clientSummary: null,
      activeClientId,
    };
  }

  const userSummary = await getUserSummary();
  const clientSummaryResponse = await getClientSummary();
  const summarizedClientIds = clientSummaryResponse.data.map(client => client.id);
  const authorizedClientIds =
    summarizedClientIds.length > 0
      ? summarizedClientIds
      : userSummary.client_ids || loginResponse.client_ids || [];
  const activeClientId = resolveTargetClientId(
    userSummary.id || loginResponse.id,
    authorizedClientIds,
    preferredClientId
  );
  const clientSummary =
    clientSummaryResponse.data.find(client => client.id === activeClientId) ||
    clientSummaryResponse.data[0] ||
    null;

  return {
    loginResponse,
    userSummary,
    clientSummary,
    activeClientId,
  };
}
